import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'

import { openModal } from 'store/actions/modals'
import { ScheduleMenuItem } from 'Manager/Schedule/SchedulerContextMenu/helpers'
import { ACTIONS } from 'Manager/Schedule/SchedulerContextMenu/constants'

export type SingleItemsMobile = { [key: string]: ScheduleMenuItem & { onClick: () => void } }

const useSingleItemsMobile = (event: MData.SchedulerEvent): SingleItemsMobile => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  return {
    [ACTIONS.EDIT]: {
      text: t('manager.schedule.CONTEXT_MENU.EDIT_SHIFT'),
      order: 1,
      onClick: () => dispatch(openModal('ScheduleEditModal', { _id: event.id }))
    },
    [ACTIONS.EDIT_USER]: {
      text: t('manager.schedule.CONTEXT_MENU.EDIT_SHIFT'),
      order: 1,
      onClick: () => dispatch(openModal('ScheduleAssignEmployeeModal', { ids: [event.id] }))
    },
    [ACTIONS.UNASSIGN_EMPLOYEE]: {
      text: t('manager.schedule.CONTEXT_MENU.UNASSIGN_EMPLOYEE'),
      order: 2,
      onClick: () => dispatch(openModal('ScheduleUnassignEmployeeModal', { ids: [event.id] }))
    },
    [ACTIONS.PUBLISH]: {
      text: t('manager.schedule.CONTEXT_MENU.PUBLISH'),
      order: 3,
      onClick: () => dispatch(openModal('SchedulePublishModal', { shiftIds: [event.id] }))
    },
    [ACTIONS.UNPUBLISH]: {
      text: t('manager.schedule.CONTEXT_MENU.UNPUBLISH'),
      order: 4,
      onClick: () => dispatch(openModal('ScheduleUnpublishModal', { shiftIds: [event.id] }))
    },
    seeConfirmationStatus: {
      text: t('manager.schedule.CONTEXT_MENU.SEE_CONFIRMATION_STATUS'),
      order: 2,
      onClick: () => dispatch(openModal('ScheduleConfirmationsModal', event.isTimeOff ? { timeOffIds: [event.id] } : { shiftIds: [event.id] }))
    },
    [ACTIONS.CANCEL]: {
      text: t('manager.schedule.CONTEXT_MENU.CANCEL'),
      order: 5,
      onClick: () => {
        dispatch(openModal('ScheduleCancelModal', { ids: [event.id] }))
      }
    },
    [ACTIONS.RESTORE]: {
      text: t('manager.schedule.CONTEXT_MENU.RESTORE_SHIFT'),
      order: 5,
      onClick: () => dispatch(openModal('ScheduleRestoreModal', { ids: [event.id] }))
    },
    [ACTIONS.CREATE_PUNCHCARD]: {
      text: t('manager.schedule.CONTEXT_MENU.CREATE_PUNCHCARD'),
      order: 6,
      onClick: () => {
        history.push({ pathname: `/manage/punch/cards/new/`, state: { shift: event } })
      }
    },
    [ACTIONS.CREATE_ATTENDANCE]: {
      text: t('manager.schedule.CONTEXT_MENU.CREATE_LEAVE'),
      order: 7,
      onClick: () => dispatch(openModal('ScheduleCreateAttendance', { shift: event }))
    },
    [ACTIONS.CREATE_LIST]: {
      text: t('manager.schedule.CONTEXT_MENU.CREATE_LIST'),
      order: 8,
      onClick: () => dispatch(openModal('ContactListCreationModal', { ids: [event.id] }))
    },
    [ACTIONS.GO_TO_USER]: {
      text: t('manager.schedule.CONTEXT_MENU.OPEN_USER'),
      order: 9,
      onClick: () => history.push(`/manage/users/${event.employeeId}`)
    },
    [ACTIONS.GO_TO_USER_SCHEDULE]: {
      text: t('manager.schedule.CONTEXT_MENU.OPEN_USER_SCHEDULE'),
      order: 10,
      onClick: () => dispatch(openModal('ScheduleOpenEmployeeSchedule', { employeeId: event.employeeId, defaultDate: event.start }))
    },
    [ACTIONS.GO_TO_CONTACT_LIST]: {
      text: t('manager.schedule.CONTEXT_MENU.OPEN_THE_SHIFT_CONTACT_LIST_MOBILE'),
      order: 11,
      onClick: () => history.push(`/manage/contact/lists/${event.contactListId}`)
    },
    [ACTIONS.GO_TO_PUNCHCARD]: {
      text: t('manager.schedule.CONTEXT_MENU.OPEN_PUNCH_CARD_MOBILE'),
      order: 12,
      onClick: () => history.push(`/manage/punch/cards/${event.punchCardId}`)
    }
  } as const
}

export { useSingleItemsMobile }
